import React from 'react';
import { useSelector } from 'react-redux';
import { createTimezonedDate } from '../../../date';
export default function CommentsSection(_ref) {
  let {
    comments
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const styleCommon = {
    color: 'black',
    padding: '10px'
  };
  const styleOtherUserCommentBody = {
    ...styleCommon,
    backgroundColor: '#f2f2f2'
  };
  const styleOwnCommentBody = {
    ...styleCommon,
    backgroundColor: '#a0f7ff',
    float: 'right',
    clear: 'both'
  };
  const commentUi = comment => {
    const isOwnComment = comment.user?.id === user.id;
    const float = isOwnComment ? 'right' : 'unset';
    return /*#__PURE__*/React.createElement("div", {
      key: comment.id,
      className: "mb-3",
      style: {
        float,
        clear: 'both',
        marginRight: '10px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        float
      }
    }, comment.user?.name), /*#__PURE__*/React.createElement("div", {
      style: isOwnComment ? styleOwnCommentBody : styleOtherUserCommentBody
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        float,
        overflowWrap: 'anywhere'
      }
    }, comment.body), /*#__PURE__*/React.createElement("div", {
      style: {
        clear: 'both',
        color: '#737373'
      }
    }, createTimezonedDate(new Date(comment.created_at)).toCustomLocaleTimeString())));
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      maxHeight: '500px',
      overflowY: 'auto',
      padding: '0 0px'
    }
  }, comments.map(comment => commentUi(comment)));
}